import AsyncStorage from "@react-native-async-storage/async-storage";

const setData = async (key, value) => {
  try {
    await AsyncStorage.setItem(key, JSON.stringify({ value }));
  } catch (e) {
    // saving error
  }
};

const getData = async (key) => {
  try {
    const obj = await AsyncStorage.getItem(key);
    return JSON.parse(obj || {}).value;
  } catch (e) {
    // error reading value
  }
};

const removeData = async (key) => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (e) {}
};

const getAppListValue = async () => {
  try {
    const t = await AsyncStorage.getItem("getAppList");
    return t;
  } catch (e) {}
};

export { setData, getData, removeData, getAppListValue };
